import { merge } from "lodash";
import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";
import logo from "../../images/dpdLogoRedDark.png";
import baseRed, { images as baseRedImages } from "./baseRed";
import { THEMES } from "../constants";
export const images = { ...baseRedImages,
  logo
};
const themeOptions = {
  name: THEMES.RED_DARK
};
export default merge({}, baseRed, themeOptions);